module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-12.04d88415.jpg";